import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {

  constructor(private authService: AuthService, private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    try{
      let token = sessionStorage.getItem('authToken');
      // if sessionStorage is empty, try to restore from localStorage (cross-tab login)
      if (!token) {
        const tokenLocal = localStorage.getItem('authToken');
        const extrasLocal = localStorage.getItem('authTokenExtras') || '';
        if (tokenLocal) {
          // restore into sessionStorage via AuthService to keep subjects in sync
          this.authService.saveToken(tokenLocal, extrasLocal);
          token = tokenLocal;
        }
      }
      if (!token) {
        this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
        return false;
      }
      const exp = this.authService.getTokenExpired(token);
      const expired = this.authService.isTokenExpired(exp);
      if (expired) {
        this.authService.removeToken();
        this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
        return false;
      }
      return true;
    } catch (e) {
      this.router.navigate(['/login']);
      return false;
    }
  }

}
